module.exports = __webpack_public_path__ + "static/media/image.01cefa13.png";